module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "ds-agenda-day",
    class: _vm.classes,
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.add($event)
      }
    }
  }, [_vm._l((_vm.visibleEvents), function(event, i) {
    return [_c('ds-agenda-event', _vm._g(_vm._b({
      key: event.id,
      attrs: {
        "read-only": _vm.readOnly,
        "calendar-event": event,
        "calendar": _vm.calendar,
        "first": i === 0,
        "siblings": _vm.visibleEvents.length
      }
    }, 'ds-agenda-event', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64bbe350","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AgendaDay.vue
// module id = 175
// module chunks = 0